import styles from "../../VpnActive/VpnActive.module.css";
import UserStore from "../../../store/user-store";
import Lottie from "react-lottie";
import React, {useRef, useState} from "react";
import {useHaptic} from "../../../Hooks/useHaptic";
import {PushWalletConnect} from "../../Notification/PushWalletConnect";
import copyAnimations from "../../Lottie/copy.json";

export const CopyTunnel = (
    {
        config,
        isRu
    }
) => {
    const elementRef = useRef(null);
    const lottieRef = useRef(null);
    const {hapticFeedBack} = useHaptic("success")
    const [isCopy, setCopy] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);

    async function copyToClipboard(text) {
        try {
            await navigator.clipboard.writeText(atob(text));
        } catch (err) {
        }
    }

    function startResetTimerCoptPush() {
        setTimeout(() => {
            setCopy(false)

        }, 2000);

    }

    const handleAnimationComplete = () => {
        setTimeout(() => setIsPlaying(false), 200)
    };

    const defaultOptions = {
        loop: false,
        autoplay: false,
        animationData: copyAnimations,
        speed: 0.2,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <>
            {isCopy && <PushWalletConnect push_text={"Tunnel copied"}/>}
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    color: "white",
                }}
            >
                <h3
                    style={{
                        fontSize: "16px",
                        fontWeight: "500",
                    }}
                >{isRu ? "Скопировать конфигурацию" : "Copy tunnel"}</h3>
                <div ref={elementRef} className={styles.vpn__copy_tunnel__text} onClick={() => {
                    copyToClipboard(config)
                    setCopy(true)
                    hapticFeedBack()
                    setIsPlaying(true)
                    startResetTimerCoptPush()
                }
                }>
                    <p>{atob(config)}</p>
                    <div className={styles.vpn__copy_tunnel__text_svg}>
                        <Lottie
                            options={defaultOptions}
                            height={30}
                            width={30}
                            isStopped={!isPlaying}
                            isPaused={false}
                            ref={lottieRef}
                            eventListeners={[
                                {
                                    eventName: "complete",
                                    callback: handleAnimationComplete,
                                },
                            ]}

                        />
                    </div>
                </div>
            </div>
        </>
    )
}